import { useEffect, type ReactNode } from 'react';
import { useMeQuery } from '@/api/queries';
import { useAuthStore } from './useAuth';

export function AuthProvider({ children }: { children: ReactNode }) {
  const setUser = useAuthStore((s) => s.setUser);
  const setStatus = useAuthStore((s) => s.setStatus);
  const { data, isLoading, isError, isSuccess } = useMeQuery();

  useEffect(() => {
    if (isLoading) setStatus('loading');
    else if (isSuccess && data) setUser(data);
    else if (isError) setUser(null);
  }, [data, isLoading, isError, isSuccess, setUser, setStatus]);

  return <>{children}</>;
}
